import React, { useContext } from "react";
import { UserContext } from "../../context/UserContext";
import { deleteCookie } from "../../utils/cookies";
import "./styles.scss";
import { Icon } from "../Icon";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../utils/hooks/useIsAuth";

type Props = {
  setIsOpen: (isOpen: boolean) => void;
};

const UserDropDown: React.FC<Props> = ({ setIsOpen }) => {
  const { user } = useContext(UserContext);
  const { setIsAuth } = useAuth();
  const userName = user?.name;
  const email = user?.email;
  const location = useLocation();

  const handleEditProfile = () => {
    setIsOpen(false);
  };
  const handleLogout = () => {
    try {
      deleteCookie("accessToken");
      deleteCookie("refreshToken")
      setIsAuth(false);
    } catch (e) {
      console.log(e);
    }
    setIsOpen(false);
  };

  return (
    <div className="dropdown">
      <div className="dropdown__menu">
        {user?.email && user?.name && (
          <div className="dropdown__item">
            <p className="dropdown__name">{userName}</p>
            <p className="dropdown__email">{email}</p>
          </div>
        )}
        {location.pathname !== "/admin" && (
          <Link to={"/edit-profile"}>
            <div className="dropdown__option" onClick={handleEditProfile}>
              <Icon iconName="edit_icon" />
              <p>Editar perfil</p>
            </div>
          </Link>
        )}
        <div className="dropdown__option" onClick={handleLogout}>
          <Icon iconName="logout_icon" className="logout_icon" />
          <p className="dropdown__logout">Cerrar sesión</p>
        </div>
      </div>
    </div>
  );
};

export default UserDropDown;
